import React from 'react';
import {vCard} from './../Utilities/vcard';
import { PersonAdd } from '@styled-icons/evaicons-solid'

export const Vcard = ({contactData,buttonText}) => {
	    const exportVCard = () => {
	    	let user = {}
	    	user["version"] = "4.0"
	    	user["n"] = contactData["supplier_db.org_name"] + ";;"
	    	user["fn"] = contactData["suppleir_db.org_name"]
	    	user["fn"] = contactData["supplier_db.org_name"]
	    	user["title"] = "UPick Berry Farm"

	    	user["adr"] = {}

	    	user["adr"]["value"] = ";;" + ((contactData["supplier_db.address_line_1"]) 
						? contactData["supplier_db.address_line_1"] + ";" : "") + 
					((contactData["supplier_db.city"]) ? contactData["supplier_db.city"] + ";" : "") 
					+ ((contactData["supplier_db.state_or_province"]) ? contactData["supplier_db.state_or_province"] + ";" :"") 
					+ ((contactData["supplier_db.postal_code"]) ? ((contactData["supplier_db.postal_code"].includes("-")) ? contactData["suppleir_db.postal_code"] + ";" : contactData["supplier_db.postal_code"] + ";" ) : "") 
					+ ((contactData["supplier_db.country_name"]) ? ((contactData["supplier_db.country_name"] === "United States") ? "USA" : contactData["supplier_db.country_name"]):"")
	    	
	    	user["adr"]["type"] = "work"
	    	user["email"] = (contactData["supplier_db.email"]) ? contactData["supplier_db.email"] : ""

	    	user["url"] = (contactData["supplier_db.website"]) ? contactData["supplier_db.website"] : ""

			vCard.export(user, user["fn"].replace(" ","-"), true) // use parameter true to force download
	    }
		return (
			<div className="add-to-contacts-button-container">
				<button onClick={()=>{
					exportVCard()}} className="add-to-contacts-button"><div className='add-to-contacts-icon'>
              			<PersonAdd />
            	</div> {buttonText}</button>
			</div>
			)
}